import { createSlice } from "@reduxjs/toolkit";

const initialState ={ 
    manutenzione:[],
    singleManutenzione: null,
    isLoading: false,
    error: null,
    tipologiaIntervento:[],
    statoIntevento:[],
    enumsLoading:{
        tipologiaIntervento:false,
        statoIntevento:false,
    },
    enumsError:{
        tipologiaIntervento:null,
        statoIntevento:null,
    },
}

const manutenzioneSlice = createSlice({
    name: "manutenzione",
    initialState,
    reducers:{
        setManutenzione:(state, action) => {
            state.manutenzione = action.payload;
        },
        addManutenzione:(state, action) => {
            state.manutenzione.push(action.payload);
        },
        addManutenzioneId:(state, action) => {
            state.singleManutenzione = action.payload;
        },
        updateManutenzione:(state, action) => {
            const index = state.manutenzione.findIndex(
                (item) => item.id === action.payload.id
              );
              if (index !== -1) {
                state.manutenzione[index] = action.payload;
              }
        },
        deleteManutenzione:(state, action) => {
            state.manutenzione = state.manutenzione.filter(
                (item) => item.id !== action.payload
            )
        },
        apiRequestStart: (state) => {
            state.isLoading = true;
            state.error = null;
          },
          apiRequestSuccess: (state) => {
            state.isLoading = false;
          },
          apiRequestFailure: (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
          },
          setTipologiaIntervento:(state, action) => {
            state.tipologiaIntervento = action.payload
          },
          setStatoIntevento:(state, action) =>{
            state.statoIntevento = action.payload
          },

          enumRequestStart: (state, action) => {
            state.enumsLoading[action.payload] = true;
            state.enumsError[action.payload] = null;
          },
          enumRequestSuccess: (state, action) => {
            state.enumsLoading[action.payload] = false;
          },
          enumRequestFailure: (state, action) => {
            const { enumType, error } = action.payload;
            state.enumsLoading[enumType] = false;
            state.enumsError[enumType] = error;
          }
    },
})

export  const{
    setManutenzione,
    addManutenzione,
    addManutenzioneId,
    updateManutenzione,
    deleteManutenzione,
    apiRequestStart,
    apiRequestFailure,
    apiRequestSuccess,
    enumRequestFailure,
    enumRequestSuccess,
    enumRequestStart,
    setTipologiaIntervento,
    setStatoIntevento
}=manutenzioneSlice.actions;

export const selectManutenzione = (state) =>  state.manutenzione?.manutenzione
export const selectSingleManutenzione = (state) => state.manutenzione?.singleManutenzione;
export const selectIsLoading = (state) => state.manutenzione?.isLoading;
export const selectError = (state) => state.manutenzione?.error;
export const selectTipologiaIntervento = (state) => state.manutenzione?.tipologiaIntervento
export const selectStatoIntervento = (state) => state.manutenzione?.statoIntevento

export default manutenzioneSlice.reducer;
